/**
 * appwrite queries are returning fields such as $permissions and other things.
 * Since there is no way to tell to appwrite to omit some fields from the results,
 * but we can only tell which fields to include, we need to use this map to include only the fields we need.
 * UPDATE:
 * it didn't work, even with explicit select, the following fields are still returned:
 * $permissions, $updatedAt, $createdAt, $collectionId, $tableId, $databaseId
 *
 * Opened an issue on their discord channel:
 * https://discord.com/channels/564160730845151244/1459461542817959979
 *
 * keeping this work because it may be useful in case they fix the issue.
 */
export const fineGradedFieldsMap = {
    users: [
        'name',
        'email',
        'last_active_at',
        'preferred_currency',
        'date_format',
        'onboarding_completed',
    ],
    transactions: [
        'bank_account_id',
        'provider_transaction_id',
        'provider_account_id',
        'amount',
        'currency',
        'description',
        'description_indexed',
        'transaction_date',
        'transaction_type',
        'status',
        'category_id',
        'notes',
        'merchant_name',
        'reference',
        'is_reconciled',
        'sync_status',
        'last_synced_at',
        'applied_rules',
        'user_ids',
    ],
    categories: [
        'name',
        'color',
        'text_color',
        'icon',
        'description',
        'is_default',
    ],
    bank_accounts: [
        'provider_account_id',
        'provider_institution_id',
        'provider_connection_id',
        'account_name',
        'account_type',
        'currency',
        'iban',
        'current_balance',
        'available_balance',
        'last_balance_update',
        'is_active',
        'sync_enabled',
        'last_synced_at',
        'sync_status',
        'sync_error',
        'requisition_id',
        'is_shared',
        'provider',
    ],
    bank_connections: [
        'requisition_id',
        'reference_id',
        'institution_id',
        'agreement_id',
        'provider',
        'provider_base_url',
        'provider_token',
    ],
    rules: [
        'title',
        'description',
        'active',
        'order',
        'strict',
        'triggers.*',
        'raw',
        'actions.*',
        'humanReadable',
        'ruleGroups.*',
    ],
    'rule-groups': ['name', 'order', 'rules.*'],
    rule_triggers: [],
    rule_actions: [],
    import_duplicates_temp: [],
    reports: [],
    user_plans: ['user_id', 'user_plan', 'started_at'],
    user_ai_usage: ['user_id', 'period', 'items_used'],
};
export const APP_COLLECTIONS = {
    BANK_CONNECTIONS: 'bank_connections',
    TRANSACTIONS: 'transactions',
    CATEGORIES: 'categories',
    BANK_ACCOUNTS: 'bank_accounts',
    BUDGETS: 'budgets',
    RULES: 'rules',
    RULE_GROUPS: 'rule-groups',
    RULE_TRIGGERS: 'rule_triggers',
    RULE_ACTIONS: 'rule_actions',
    IMPORT_DUPLICATES_TEMP: 'import_duplicates_temp',
    REPORTS: 'reports',
    WAITLIST: 'waitlist',
    USER_PLANS: 'user_plans',
    USER_AI_USAGE: 'user_ai_usage',
};
